import { useLoader } from '@react-three/fiber';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js';
import { TextureLoader } from 'three';
import { useMemo } from 'react';

export default function TreeModel({ position = [0, 0, 0] }) {
  // console.log('Rendering TreeModel at position:', position);

  const materials = useLoader(MTLLoader, '/objs/tree/tree1.mtl');
  materials.preload();

  const obj = useLoader(OBJLoader, '/objs/tree/tree1.obj', (loader) => {
    loader.setMaterials(materials);
  });

  const barkTexture = useLoader(TextureLoader, '/objs/tree/bark_1.png');
  const leafTexture = useLoader(TextureLoader, '/objs/tree/leaf_1.png');

  // Clone the loaded object for each instance
  const clonedObj = useMemo(() => {
    const clone = obj.clone(true);
    clone.traverse((child) => {
      if (child.isMesh) {
        // If material is an array, assign textures to each by name
        if (Array.isArray(child.material)) {
          child.material.forEach((mat) => {
            if (mat.name === 'tree') {
              mat.map = barkTexture;
              mat.needsUpdate = true;
            }
            if (mat.name === 'leaf') {
              mat.map = leafTexture;
              mat.needsUpdate = true;
            }
          });
        } else {
          if (child.material.name === 'tree') {
            child.material.map = barkTexture;
            child.material.needsUpdate = true;
          }
          if (child.material.name === 'leaf') {
            child.material.map = leafTexture;
            child.material.needsUpdate = true;
          }
        }
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    return clone;
  }, [obj, barkTexture, leafTexture]);

  return (
    <primitive
      object={clonedObj}
      castShadow
      receiveShadow
      scale={2}
      position={position}
    />
  );
}